import React from 'react';
import classNames from 'classnames';
import { Draggable } from '@hello-pangea/dnd';
import { Icon } from 'Permafrost/index';
import { StyledDragDropListItem } from './DragDropList.styles';
export const DragDropListItem = ({ id, content, dragDisabled, index }) => {
    const stringContent = typeof content === 'string';
    return (React.createElement(Draggable, { draggableId: id, index: index, isDragDisabled: dragDisabled }, (provided, snapshot) => (React.createElement(StyledDragDropListItem, Object.assign({ className: classNames({
            'is-dragging': snapshot.isDragging,
            'drag-disabled': dragDisabled,
        }), ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps),
        !dragDisabled ? React.createElement(Icon, { className: "draggable-icon", name: "draggable", size: [20] }) : null,
        React.createElement("span", { className: classNames('draggable-content', { string: stringContent }) }, content)))));
};
//# sourceMappingURL=DragDropListItem.js.map